import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
  createCustomerProduct,
  createProduct,
  createProductBom,
  createProductInventory,
  createProductInventoryLog,
  createVendor,
  createVendorPart,
  editCustomerProduct,
  editProduct,
  editProductBom,
  editProductInventory,
  editProductInventoryLog,
  editVendor,
  editVendorPart,
  loadCustomerProduct,
  loadCustomerProducts,
  loadProduct,
  loadProductBom,
  loadProductBoms,
  loadProductInventories,
  loadProductInventory,
  loadProductInventoryLog,
  loadProductInventoryLogs,
  loadProducts,
  loadVendor,
  loadVendorPart,
  loadVendorParts,
  loadVendors,
  removeCustomerProduct,
  removeProduct,
  removeProductBom,
  removeProductInventory,
  removeProductInventoryLog,
  removeVendor,
  removeVendorPart,
} from '@sophocles/features/warehouse/products/api';
import {
  CustomerProductSchema,
  ProductBomSchema,
  ProductInventoryLogSchema,
  ProductInventorySchema,
  ProductSchema,
  VendorPartSchema,
  VendorSchema,
} from '@sophocles/features/warehouse/products/schema';
import { createEntitySlice } from '@sophocles/utils/slice';
import { normalize, schema } from 'normalizr';

// Generate slices for each schema
const vendorSlice = createEntitySlice(
  'vendors',
  VendorSchema,
  loadVendors,
  loadVendor,
  createVendor,
  editVendor,
  removeVendor,
  'warehouse',
);

const vendorPartSlice = createEntitySlice(
  'vendorParts',
  VendorPartSchema,
  loadVendorParts,
  loadVendorPart,
  createVendorPart,
  editVendorPart,
  removeVendorPart,
  'warehouse',
);

const customerProductSlice = createEntitySlice(
  'customerProducts',
  CustomerProductSchema,
  loadCustomerProducts,
  loadCustomerProduct,
  createCustomerProduct,
  editCustomerProduct,
  removeCustomerProduct,
  'warehouse',
);

const productSlice = createEntitySlice(
  'products',
  ProductSchema,
  loadProducts,
  loadProduct,
  createProduct,
  editProduct,
  removeProduct,
  'warehouse',
);

const productBomSlice = createEntitySlice(
  'productBoms',
  ProductBomSchema,
  loadProductBoms,
  loadProductBom,
  createProductBom,
  editProductBom,
  removeProductBom,
  'warehouse',
);

const productInventorySlice = createEntitySlice(
  'productInventories',
  ProductInventorySchema,
  loadProductInventories,
  loadProductInventory,
  createProductInventory,
  editProductInventory,
  removeProductInventory,
  'warehouse',
);

const productInventoryLogSlice = createEntitySlice(
  'productInventoryLogs',
  ProductInventoryLogSchema,
  loadProductInventoryLogs,
  loadProductInventoryLog,
  createProductInventoryLog,
  editProductInventoryLog,
  removeProductInventoryLog,
  'warehouse',
);

export {
  vendorSlice,
  vendorPartSlice,
  customerProductSlice,
  productSlice,
  productBomSlice,
  productInventorySlice,
  productInventoryLogSlice,
};
